import {Component, ElementRef, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {NavigationEnd, Router} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import {AuthService} from 'common-domain';
import {ApplicationUpdateService} from './application-update.service';
import {gitVersion} from '../environments/git-version';
import {PATH_CONSTANTS} from './app-routing.module';
import {USER_PATH_CONSTANTS} from './user/user-routing.module';
import {
  TermsAndPrivacyAcknowledgmentService
} from "./home/terms-and-privacy-acknowledgment/terms-and-privacy-acknowledgment.service";

declare var jQuery: any;

@Component({
    selector: 'rzm-iana-tld-manager',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  gitInfo: string;

  constructor(private titleService: Title,
              private router: Router,
              private swUpdate: ApplicationUpdateService,
              @Inject(PLATFORM_ID) private platformId: Object,
              private _elementRef: ElementRef,
              public termsAndPrivacyAcknowledgmentService: TermsAndPrivacyAcknowledgmentService) {
    this.swUpdate.checkForUpdates();
    this.gitInfo = gitVersion.commitLong + " on " + gitVersion.date + ", build number : " + gitVersion.buildNumber;
  }



  // @HostListener('window:focus', ['$event'])
  // onFocus(event: FocusEvent): void {
  //   if (this.router.url.indexOf("signup") <= -1 || this.router.url.indexOf("reset") <= -1) {
  //     if (!this.authService.isLoggedIn()) {
  //       this.authService.redirectToHome('Logged out');
  //     } else if (this.router.url === "/home") {
  //       this.router.navigateByUrl("/user/home");
  //     }
  //   }
  // }


  ngOnInit(): void {
    this._elementRef.nativeElement.removeAttribute("ng-version");
    this.removeRootSpinner();
    this.titleService.setTitle('RZM - TLD Manager');
    if (isPlatformBrowser(this.platformId)) {
      // Initialize the Foundation JavaScript
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {

          jQuery(document).ready(function () {
            if (jQuery(window).width() < 640) {
              jQuery('#responsive-menu').addClass('mobile-menu');
            } else {
              jQuery('#responsive-menu').removeClass('mobile-menu');
            }
            jQuery('#mobile-menu-trigger').off().on('click', function () {
              jQuery('#responsive-menu').show();
            });

            jQuery(window).resize(function () {
              if (jQuery(this).width() < 640) {
                jQuery('#responsive-menu').addClass('mobile-menu');

              } else {
                jQuery('#responsive-menu').removeClass('mobile-menu');
              }
            });

            jQuery('.close-mobile-menu').off().on('click', function () {
              jQuery('#responsive-menu').hide();
            });
          });
        }
      });
    }
  }

  navigateToSettings() {
    this.router.navigate([PATH_CONSTANTS.USER + PATH_CONSTANTS.SLASH + USER_PATH_CONSTANTS.USER_SETTINGS], {
      state: {
        staffView: false
      }
    });
  }

  private removeRootSpinner() {
    try {
      const spinner = document.getElementById('index-spinner');
      spinner.parentNode.removeChild(spinner);
    } catch (e) {
      // when ssr
    }
  }
}
